import React from 'react';

function LogKV({ label, value }) {
  if (!value && value !== 0) return null;
  const strVal = String(value);
  return (
    <div className="log-kv-row">
      <span className="log-kv-key">{label}</span>
      <span className="log-kv-val">{strVal}</span>
    </div>
  );
}

export default LogKV;
